import { pages } from './pages'
import { main } from '@/lang/en/main.ts'
import { errors } from '@/lang/en/errors.ts'

export default {
  main,
  pages,
  errors,
}